// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    createdAt: z.number().optional(),
    verifiedIdentifier: z.string().max(255).nullable().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    createdAt: z.number(),
    verifiedIdentifier: z.string().max(255).nullable(),
});
export const VerificationStatuses = Object.freeze({
    table: 'verification_statuses',
    tableSingular: 'verification_status',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        userId: 'user_id',
        createdAt: 'created_at',
        verifiedIdentifier: 'verified_identifier',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'userId',
        'createdAt',
        'verifiedIdentifier',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
